import { render, staticRenderFns } from "./loss.vue?vue&type=template&id=48c9b311&scoped=true&"
import script from "./loss.vue?vue&type=script&lang=js&"
export * from "./loss.vue?vue&type=script&lang=js&"
import style0 from "./loss.vue?vue&type=style&index=0&id=48c9b311&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c9b311",
  null
  
)

export default component.exports